// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper_Wrapper__1sjFS","center":"Wrapper_center__29Y6i"};